import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors } from '../constants';

export const Info = styled.div`
  margin-bottom: 12px;
`;

export const SubTitle = styled.h2`
  margin-top: 12px;
  margin-bottom: 18px;
`;

export const BackgroundBox = styled.div`
  position: relative;
  background: ${colors.secondaryBackground};
  border-radius: 3px;
  padding: 32px 32px 24px;
  margin-bottom: 32px;
  & > a {
    color: ${colors.secondaryDark};
  }
  & > h1 {
    color: ${colors.secondaryDark};
  }
  & > h2 {
    color: ${colors.secondaryDark};
  }
  & > h3 {
    color: ${colors.secondaryDark};
  }
  & > h4 {
    color: ${colors.secondaryDark};
  }
  @media (min-width: 1000px) {
    margin-left: -32px;
    margin-right: -32px;
  }
`;

export const Icon = styled(FontAwesomeIcon)`
  margin-right: 0.5em;
`;

export const PrintButton = styled.button`
  color: ${colors.primaryDark};
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: 0.8rem;
  &:hover,
  &:focus,
  &active {
    color: ${colors.primary};
  }
  @media print {
    display: none;
  }
`;

export const ShowMoreButton = styled.button`
  padding: 4px 8px;
  margin-left: 0.5em;
  background: none;
  border: none;
  border-radius: 1px;
  font-size: 0.8rem;
  color: ${colors.primaryDark};
  text-transform: uppercase;
  cursor: pointer;
  &:hover {
    background: ${colors.primaryBackground};
  }
`;

export const FloatRight = styled.div`
  float: right;
`;
